import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { db, doc, getDoc } from "../config/firebase";
import AdminOverview from "../components/AdminOverview";
import AdminOrders from "../components/AdminOrders";
import AdminProducts from "../components/AdminProducts";
import AdminStoreHours from "../components/AdminStoreHours";
import "./AdminDashboard.css";

const AdminDashboard = () => {
  const { user, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [checking, setChecking] = useState(true);
  const [activeTab, setActiveTab] = useState("overview");
  const navigate = useNavigate();

  const checkAdmin = useCallback(async () => {
    try {
      const adminDoc = await getDoc(doc(db, "admins", user.uid));
      if (adminDoc.exists()) {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }
    } catch (err) {
      console.error("Error checking admin:", err);
      setIsAdmin(false);
    } finally {
      setChecking(false);
    }
  }, [user]);

  useEffect(() => {
    if (!authLoading && !user) {
      navigate("/login");
      return;
    }
    if (user) {
      checkAdmin();
    }
  }, [user, authLoading, navigate, checkAdmin]);

  if (authLoading || checking) {
    return (
      <div className="admin-page">
        <div className="admin-loading-full">
          <div className="spinner"></div>
          <p>Checking access...</p>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="admin-page">
        <div className="admin-denied">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ff4757" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
          </svg>
          <h2>Access Denied</h2>
          <p>You don't have permission to access the admin dashboard.</p>
          <button className="btn-back" onClick={() => navigate("/")}>Go Home</button>
        </div>
      </div>
    );
  }

  const tabs = [
    { id: "overview", label: "Overview" },
    { id: "orders", label: "Orders" },
    { id: "products", label: "Products" },
    { id: "storeHours", label: "Store Hours" }
  ];

  return (
    <div className="admin-page">
      <div className="admin-container">
        <div className="admin-sidebar">
          <h2 className="admin-title">Admin Panel</h2>
          <nav className="admin-nav">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`admin-nav-item ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
        <div className="admin-content">
          {activeTab === "overview" && <AdminOverview />}
          {activeTab === "orders" && <AdminOrders />}
          {activeTab === "products" && <AdminProducts />}
          {activeTab === "storeHours" && <AdminStoreHours />}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;